import { RoleTaskNotifications } from "./RoleTaskNotifications";

/**
 * Alerts graphic designers whenever a new task lands in "With Video Editor",
 * which is the stage where a GD needs to prepare and mark GFX Given.
 */
export function GraphicDesignerNotifications() {
  return (
    <RoleTaskNotifications
      role="graphic_designer"
      targetStatus="with_editor"
      accent="#38BDF8"
      label="With Video Editor"
    />
  );
}
